import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en.json';
import mmTranslation from './locales/mm.json';
import { customStorage } from './services/CommonService';

// Define available resources
const resources = {
  en: {
    translation: enTranslation,
  },
  mm: {
    translation: mmTranslation,
  },
};

// Check for stored language or default to 'en'
const lng = customStorage.getItem('i18nextLng') || 'en';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng,
    fallbackLng: 'en', // use en if detected lng is not available
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // Allows easy adding of other languages in the future
    supportedLngs: ['en', 'mm'],
  });

export default i18n;
